// Espejo de la convención resx del sitio: el texto inglés ES la clave y una
// clave sin traducción cae al inglés. Las traducciones viven únicamente en
// Client/Resources/SharedResources.{lang}.resx; _Layout inyecta las del idioma
// actual en window.__i18n (para "en" no se inyecta nada y t devuelve la clave).
// Cacheamos la tabla de traducciones una sola vez al cargar el módulo
const isBrowser = typeof window !== "undefined";
const i18nTable = (isBrowser && window.__i18n) || null;

export function currentLanguage() {
    return (typeof document !== "undefined" && document.documentElement.lang || "en").toLowerCase();
}

export function t(key, ...args) {
    // 1. Buscar traducción (O(1) en tiempo)
    const text = (i18nTable && i18nTable[key]) || key;

    // 2. Si no hay argumentos que reemplazar, terminamos de inmediato
    if (args.length === 0) return text;

    // 3. Reemplazo en una sola pasada usando RegEx
    // Busca cualquier cosa que tenga formato {número} y lo reemplaza por el argumento indexado
    return text.replace(/\{(\d+)\}/g, (match, index) => {
        const value = args[index];
        return value !== undefined ? String(value) : match;
    });
}